import { ReceivingSubmitRequestController } from './submitRequest.controller';
import template from './submitRequest.html';

export const receivingSubmitRequestComponent = {
  name: 'receivingSubmitRequestComponent',
  restrict: 'E',
  template,
  controller: ReceivingSubmitRequestController,
  controllerAs: 'vm',
  bindings: {
    ticket: '<',
    stateIndex: '<'
  }
};
